import { jsx, jsxs } from "react/jsx-runtime";
import { Checkbox, HorizonIcon, Label, cn } from "@pcln/horizon";
const HotelOption = {
    id: 'addHotel',
    name: 'addHotel',
    label: 'Add a hotel',
    value: 'STAY',
    type: 'STAY'
};
const FlightOption = {
    id: 'addFlights',
    name: 'addFlights',
    label: 'Add a flight',
    value: 'FLY',
    type: 'FLY'
};
const CarOption = {
    id: 'addCar',
    name: 'addCar',
    label: 'Add a car',
    value: 'DRIVE',
    type: 'DRIVE'
};
function BundleAndSaveHeading({ text }) {
    return /*#__PURE__*/ jsxs("div", {
        className: "flex items-center gap-1",
        children: [
            /*#__PURE__*/ jsx(HorizonIcon, {
                name: "Discount",
                size: "16",
                palette: "success",
                shade: "8",
                "aria-hidden": true,
                "data-testid": "bundle-and-save-icon"
            }),
            /*#__PURE__*/ jsx("span", {
                className: "text-body3 font-medium whitespace-nowrap text-neutral-13",
                children: text
            })
        ]
    });
}
const productConfigs = {
    hotels: {
        defaultOptions: [
            FlightOption,
            CarOption
        ],
        defaultLabel: 'Bundle + Save'
    },
    flights: {
        defaultOptions: [
            HotelOption,
            CarOption
        ],
        defaultLabel: 'Bundle + Save'
    },
    cars: {
        defaultOptions: [
            HotelOption,
            FlightOption
        ],
        defaultLabel: 'Bundle + Save'
    }
};
function BundleAndSave({ productType, options, checkedValues, onSelectionChange, label, className = '', tripType, removeBackground = false, highlightBackground = false }) {
    const config = productConfigs[productType];
    const defaultOptions = options || config.defaultOptions;
    const defaultLabel = label || config.defaultLabel;
    let backgroundClassName = 'rounded-lg px-2 py-3 @3xl:bg-highlight-3';
    if (removeBackground) backgroundClassName = 'rounded-none px-0 py-2';
    else if (highlightBackground) backgroundClassName = 'rounded-lg bg-highlight-3 px-2 py-3';
    const containerClassName = cn('flex w-full min-w-0 flex-col gap-3 @sm:flex-row @sm:flex-wrap @sm:items-center @sm:gap-4 @3xl:h-full', backgroundClassName, className);
    function getUpdatedTripType(checked, option) {
        return checked ? `${tripType}:${option.type}` : tripType.replace(`:${option.type}`, '');
    }
    return /*#__PURE__*/ jsx("div", {
        className: "flex h-full w-full min-w-0",
        children: /*#__PURE__*/ jsxs("div", {
            className: containerClassName,
            role: "group",
            "aria-label": defaultLabel,
            children: [
                /*#__PURE__*/ jsx("div", {
                    className: "shrink-0",
                    "data-testid": "bundle-and-save-heading",
                    children: /*#__PURE__*/ jsx(BundleAndSaveHeading, {
                        text: defaultLabel
                    })
                }),
                /*#__PURE__*/ jsx("div", {
                    className: "flex flex-row flex-wrap items-center gap-4",
                    children: defaultOptions.map((option)=>{
                        const checked = checkedValues[option.value] || false;
                        return /*#__PURE__*/ jsxs(Label, {
                            htmlFor: option.id,
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ jsx(Checkbox, {
                                    size: "16",
                                    id: option.id,
                                    value: option.value,
                                    name: option.name,
                                    checked: checked,
                                    handleChange: ()=>{
                                        const newCheckedState = !checked;
                                        const updatedTripType = getUpdatedTripType(newCheckedState, option);
                                        onSelectionChange(updatedTripType, newCheckedState, option.value);
                                    }
                                }),
                                /*#__PURE__*/ jsx("span", {
                                    className: "ml-2 text-body3 whitespace-nowrap",
                                    children: option.label
                                })
                            ]
                        }, option.id);
                    })
                })
            ]
        })
    });
}
export { BundleAndSave, HotelOption };
